// Theme-local color families; original supplier color names and variants are unchanged.
const colorFamilies = [
  ['Black','#111111',['black','elegant black']],
  ['Grey','#909090',['grey','gray','charcoal','graphite','silver']],
  ['White','#ffffff',['white','ivory','cream','creamy white','milky white','off white','ecru','eggshell']],
  ['Blue','#637fae',['blue','navy','indigo','azure','aqua','cerulean','cerulean blue','turquoise','teal','denim']],
  ['Green','#659a72',['green','olive','sage','moss','mint','gum leaf','matcha','black forest','chartreuse','lime']],
  ['Brown','#765438',['brown','chocolate','coffee','mocha','cappuccino','chestnut','caramel','bronze','copper','espresso']],
  ['Red','#c61d47',['red','burgundy','wine','maroon','crimson','scarlet','cerise','sauce red']],
  ['Khaki','#ddc39e',['khaki','khakis','beige','camel','tan','taupe','oatmeal','sand','champagne','apricot','dust storm']],
  ['Pink','#efbdce',['pink','pinkish','blush','fuchsia','magenta','rose','big rose','pale blush','peach','lotus']],
  ['Orange','#ee9737',['orange','coral','burnt coral','pumpkin','tangerine','terracotta','rust','amber']],
  ['Yellow','#f1e38b',['yellow','mustard','ochre','ginger','gold']],
  ['Purple','#a99cc2',['purple','violet','lavender','lilac','mauve','periwinkle','plum','heliotrope']],
  ['Multi','conic-gradient(#ee953f,#e4d96c,#61aa94,#6388bd,#b694c7,#ee953f)',['multi','multicolor','mixed','picture','mixed color','floral','print','picture color','color','stripe','stripes','plaid','leopard','zebra','snake pattern','giraffe print','tie dye','wave point','feather','retro']]
];
const cleanColor = value => String(value ?? '').trim().toLowerCase().replace(/[-_]+/g,' ').replace(/\s+/g,' ').replace(/\s+colou?r(?:ed)?$/,'');
const colorFamily = value => {
  const clean = cleanColor(value);
  if (!clean) return '';
  // Handle directional shade names before matching color words.
  const special = {'medium':'Blue','dark':'Blue','light':'Blue','dk':'Blue','md':'Blue','solid dark':'Blue','solid medium':'Blue','yellow green':'Green','yellowish green':'Green','orange red':'Orange','reddish brown':'Brown','olive brown':'Brown','rose red':'Red','medium purplish red':'Red','blue gray':'Blue','mint blue':'Blue'};
  if (special[clean]) return special[clean];
  const exact = colorFamilies.find(f => f[2].includes(clean));
  if (exact) return exact[0];
  // Base-color modifiers (Light Blue, Coffee Brown, etc.) belong to one family.
  const families = colorFamilies.slice(0,-1).filter(f => f[2].some(alias => new RegExp('(?:^|\\b)'+alias+'(?:\\b|$)').test(clean)));
  const names = [...new Set(families.map(f=>f[0]))];
  if (names.length === 1) return names[0];
  if (names.length > 1 || /floral|flower|print|stripe|strips|plaid|polka|leopard|zebra|pattern|tie dye|combo/.test(clean)) return 'Multi';
  // Unknown supplier labels stay readable rather than receiving a misleading swatch.
  return String(value ?? '').trim();
};
const toggleColorFamilyURL = (href,param,family,values) => {
  const url = new URL(href);
  const current = url.searchParams.getAll(param);
  const wasSelected = current.some(value => colorFamily(value) === family);
  url.searchParams.delete(param);
  current.filter(value=>colorFamily(value)!==family).forEach(value=>url.searchParams.append(param,value));
  if (!wasSelected) [...new Set(values)].forEach(value=>url.searchParams.append(param,value));
  url.searchParams.delete('page');
  return url;
};
function initNativeSwatches(root=document) {
  root.querySelectorAll('[data-vc-native-colors]:not([data-vc-swatches-ready])').forEach(list=>{
    const inputs=[...list.querySelectorAll('input[type="checkbox"]')];
    if (!inputs.length) return;
    const groups=new Map();
    inputs.forEach(input=>{
      const family=colorFamily(input.value);
      if (!groups.has(family)) groups.set(family,[]);
      groups.get(family).push(input);
    });
    const grid=document.createElement('div');
    grid.className='vc-native-swatches';
    grid.setAttribute('role','group');
    grid.setAttribute('aria-label','Color');
    [...groups].sort(([a],[b])=>{
      const ai=colorFamilies.findIndex(f=>f[0]===a),bi=colorFamilies.findIndex(f=>f[0]===b);
      return (ai<0?99:ai)-(bi<0?99:bi)||a.localeCompare(b);
    }).forEach(([family,members])=>{
      const definition=colorFamilies.find(f=>f[0]===family);
      const selected=members.some(input=>input.checked);
      const available=members.some(input=>!input.closest('li')?.classList.contains('hide')&&!input.disabled);
      if (!available&&!selected) return;
      const button=document.createElement('button');
      button.type='button';
      button.className=definition?'vc-color-dot':'vc-color-name';
      button.setAttribute('aria-label',family);
      button.setAttribute('aria-pressed',String(selected));
      button.title=family+': '+members.map(input=>input.value).join(', ');
      if(definition){
        button.style.setProperty('--vc-swatch',definition[1]);
        const circle=document.createElement('span');
        circle.setAttribute('aria-hidden','true');
        button.append(circle);
      }else button.textContent=family;
      button.addEventListener('click',event=>{
        event.preventDefault();event.stopImmediatePropagation();
        location.assign(toggleColorFamilyURL(location.href,members[0].name,family,members.map(input=>input.value)).href);
      });
      grid.append(button);
    });
    if(!grid.children.length)return;
    list.closest('.collection-content')?.classList.add('vc-swatches-enhanced');
    list.hidden=true;
    list.dataset.vcSwatchesReady='true';
    list.insertAdjacentElement('afterend',grid);
  });
}
if(typeof document!=='undefined'){
  const start=()=>initNativeSwatches();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
  // Collection AJAX replaces the sidebar and mobile drawer.
  const collection=document.querySelector('.collection-content');
  if(collection)new MutationObserver(start).observe(collection,{childList:true,subtree:true});
}
export {colorFamilies,colorFamily,toggleColorFamilyURL};
